import { Accordion, ButtonText } from '@morressier/alembic';
import { faBell, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { IconBadge } from 'src/components/IconBadge';
import { EditorialRejectionContextModal } from 'src/components/Submission/modals/editorial/RejectionContext.js';
import AdditionalInformationWrapper from '../../AdditionalInformationWrapper';

export const EditorialRejectedAdditionalInfo = () => {
  const [showContextModal, setShowContextModal] = useState(false);

  return (
    <AdditionalInformationWrapper>
      <Accordion
        chakraAccordionProps={{
          width: '100%',
          defaultIndex: 0
        }}
        items={[
          {
            title: (
              <Flex alignItems={'flex-start'} gap={2}>
                <IconBadge icon={faBell} variant="neutral" />
                <Flex flexDirection={'column'} marginLeft={2}>
                  <Text textStyle="headingItem">Highlights</Text>
                  <Text textStyle="textContext">
                    Review key updates and other relevant information in this
                    phase.
                  </Text>
                </Flex>
              </Flex>
            ),
            content: (
              <Flex flexDirection="column" width="100%" gap={4}>
                <Flex gap={3} alignItems="center">
                  <IconBadge icon={faXmark} variant="attention" />
                  <Text textStyle="headingItem">Submission Rejected</Text>
                  <ButtonText
                    marginLeft="auto"
                    onClick={() => setShowContextModal(true)}
                  >
                    View Details
                  </ButtonText>
                </Flex>
              </Flex>
            )
          }
        ]}
      />

      {showContextModal && (
        <EditorialRejectionContextModal
          onClose={() => setShowContextModal(false)}
        />
      )}
    </AdditionalInformationWrapper>
  );
};
